var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentUser
    ? _c(
        "div",
        { class: _vm.routename, attrs: { id: "app_dc" } },
        [
          _c("header-bar", {
            staticClass: "d-print-none",
            attrs: { show: true },
          }),
          _c("app-main"),
          _c("footer-bar", { staticClass: "d-print-none" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }